/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import OrganizationDTO from "../../models/apiModels/OrganizationDTO";

import { UUID } from "../../models/apiModels/Organization";

export const getOrganizationNameById = (
  orgId: UUID,
  organizationOrigionaldata: OrganizationDTO[]
) => {
  var test = organizationOrigionaldata.find(
    (key: OrganizationDTO) => key?.id == orgId
  );

  return test?.name;
};
export default getOrganizationNameById;
